export default __webpack_public_path__ + "static/media/sound.ae85828c.svg";